import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal, show as modalShow } from 'redux-modal';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  InputField,
  required,
  domain
} from '../../form';

class CNameForm extends Component {

  onFormSubmit(vals) {
    const {
      dispatch,
      handleHide,
      formAction,
      cname,
      cnames
    } = this.props;

    const args = formAction === 'Update' ? [cname.uuid, vals] : [vals];
    dispatch(setLoader('CnameForm'));

    dispatch(PublisherApi.actions[`cname${formAction}`].post(...args, (error, success) => {
      dispatch(removeLoader('CnameForm'));
      if (success) {
        let collection = [...cnames.data];

        if (formAction === 'Update') {
          collection = [...cnames.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });
        } else if (formAction === 'Create') {
           collection.unshift(success.data);
        }

        dispatch({
          type: PublisherApi.events.cnames.actionSuccess,
          syncing: false,
          data: { ...cnames, data: collection, meta: { ...cnames.meta } }
        });

        handleHide();

        if (formAction === 'Create') {
          dispatch(modalShow('CnamePopModal', { cname: success.data }));
        }
      }
    }));
  }

  render() {
    const { show, handleHide, handleSubmit, heading, formAction, isLoading } = this.props;
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Modal.Body>
            <Field
              type='text'
              name='cname[domain]'
              placeholder='Example: example.com'
              label='Domain'
              component={InputField}
              validate={[required, domain]}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='primary'
            >
              {formAction || 'Next'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'CnameForm'
});

const ResourceModal = connectModal({
  name: 'CnameFormModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { CnameFormModal } } = state;
  const isLoading = loader.includes('CnameForm');
  const cname = get(CnameFormModal, 'props.cname', {});
  const cnames = get(state, 'publisher.cnames.data', {});

  const initialValues = {
    cname: {
      domain: cname.domain
    }
  };

  return { isLoading, initialValues, cnames };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(CNameForm)));
